// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__VKa7m","icon":"IconButton_icon__n22cK","active":"IconButton_active__qG6So","skeleton":"IconButton_skeleton__SX7r6"};